import { render, staticRenderFns } from "./ProductSkeletonsAdd.vue?vue&type=template&id=84c54e4a&"
import script from "./ProductSkeletonsAdd.vue?vue&type=script&lang=js&"
export * from "./ProductSkeletonsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports